import axiosPost from "./axiosPost";

export const SFLocalidadGet = async (credentials, params = {}) => {
    const body = {
        service: "SFLocalidadGet",
        params: {
            provinciaId: params?.provinciaId ?? null,
        },
    };

    return await axiosPost(body, credentials);
};
